export const INPUT_TYPE = {
    EMAIL: "email",
    PHONE: "phone",
    ZIP_CODE: "zipCode",
    AGE: "age",
    YEAR: "year",
    DATE: "date",
    YEAR: "year",
    NUMBER: "number"
}